const AddIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon" clipPath="url(#clip0_15_257)">
        <path
          id="circle-plus"
          d="M10 0C4.47656 0 0 4.47656 0 10C0 15.5234 4.47656 20 10 20C15.5234 20 20 15.5234 20 10C20 4.47656 15.5234 0 10 0ZM10 18.75C5.17578 18.75 1.25 14.8242 1.25 10C1.25 5.17578 5.17578 1.25 10 1.25C14.8242 1.25 18.75 5.17578 18.75 10C18.75 14.8242 14.8242 18.75 10 18.75ZM13.75 9.375H10.625V6.25C10.625 5.90453 10.3455 5.625 10 5.625C9.65453 5.625 9.375 5.90625 9.375 6.25V9.375H6.25C5.90625 9.375 5.625 9.65625 5.625 10C5.625 10.3438 5.90625 10.625 6.25 10.625H9.375V13.75C9.375 14.0955 9.65453 14.375 10 14.375C10.3455 14.375 10.625 14.0955 10.625 13.75V10.625H13.75C14.0955 10.625 14.375 10.3455 14.375 10C14.375 9.65453 14.0938 9.375 13.75 9.375Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_15_257">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AddIcon;
